import { render, staticRenderFns } from "./PlansList.vue?vue&type=template&id=03ca4966&scoped=true&"
import script from "./PlansList.vue?vue&type=script&lang=js&"
export * from "./PlansList.vue?vue&type=script&lang=js&"
import style0 from "./PlansList.vue?vue&type=style&index=0&id=03ca4966&prod&lang=scss&scoped=true&"
import style1 from "./PlansList.vue?vue&type=style&index=1&id=03ca4966&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ca4966",
  null
  
)

export default component.exports